import React from "react";
import { Button } from "carbon-components-react";
import { Download16 } from "@carbon/icons-react";

import exportToCsv from "@eave/shared/utils/exportToCSV";

import { Data, Schema } from "../shared";
import { formattedValue, getColumnDefByJsonKey } from "../helpers";

const downloadPipelineData = (d: Data, schema: Schema, visibleColumnKeys: string[]) => {
  const csvHeader = visibleColumnKeys.map(
    jsonKey => getColumnDefByJsonKey(schema, jsonKey).displayName,
  );
  const csvRows = d.map(row => {
    return visibleColumnKeys.map(jsonKey => {
      const columnDef = getColumnDefByJsonKey(schema, jsonKey);
      const { kind, enums } = columnDef;
      const cellValue = formattedValue(kind, row[jsonKey], enums);
      return cellValue;
    });
  });

  exportToCsv(csvHeader, csvRows, "pipeline_report.csv");
};

interface Props {
  results: Data;
  schema: Schema;
  visibleColumnKeys: string[];
}

const DownloadCSVButton: React.FC<Props> = ({ results, schema, visibleColumnKeys }) => (
  <Button
    kind="ghost"
    renderIcon={Download16}
    onClick={() => downloadPipelineData(results, schema, visibleColumnKeys)}
  >
    Download CSV
  </Button>
);

export default DownloadCSVButton;
